import { Box, Container, Grid } from '@material-ui/core';
import { PageLoader, SGSCard, SGSButton, SGSBadge } from 'components';
import { usePageTitleContext } from 'core/contexts';
import { useQuery } from 'core/hooks';
import { ArticleMode, ArticleModeRouteNames } from 'core/models';
import { actualiteService } from 'core/services';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router';
import styles from '../../Actualites.module.scss';

type Props = {
    mode: ArticleMode;
};

const ActualiteArticleShow: React.FC<Props> = ({ mode }) => {
    const { slug } = useParams<any>();
    const history = useHistory();
    const { t } = useTranslation();
    const { data, loading } = useQuery(actualiteService.getArticleBySlug, mode, slug);
    const { setPageTitle } = usePageTitleContext();

    useEffect(() => {
        if (!data) {
            return;
        }
        setPageTitle(data?.article?.title);
    }, [data, setPageTitle]);

    return (
        <Container maxWidth="md">
            <Grid container justifyContent="space-between" className="mb-4">
                <SGSButton
                    variant="outlined"
                    className="mr-2"
                    onClick={() => {
                        history.push(`/${ArticleModeRouteNames[mode]}`);
                    }}
                >
                    {t('global.back')}
                </SGSButton>
                {data?.tags.length > 0 && (
                    <Box display="flex" alignItems="flex-end">
                        {data.tags.map((o) => (
                            <Grid item alignItems="flex-end">
                                <SGSBadge color="darkorange">{o.name}</SGSBadge>
                            </Grid>
                        ))}
                    </Box>
                )}
            </Grid>
            <PageLoader loading={loading}>
                <SGSCard>
                    <div className={styles.articleContent} dangerouslySetInnerHTML={{ __html: data?.article?.content }}></div>
                </SGSCard>
            </PageLoader>
        </Container>
    );
};

export default ActualiteArticleShow;
